import {createSetKeysDataAction} from "../actions/dataActions";
import { useGetAndSet } from "./useGetAndSet";


export const useKeysData = (params) => {
    return useGetAndSet("keys", params, createSetKeysDataAction);
}